var _circle, _circle2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedmarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8086,
    cy: 19,
    r: 19,
    fill: "#FF4341"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.8086,
    cy: 19,
    r: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3086 18C15.3086 15.5147 17.3233 13.5 19.8086 13.5C22.2939 13.5 24.3086 15.5147 24.3086 18V23.4H15.3086V18Z",
    fill: "#FF4341"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9082 19.7999C18.9082 19.3028 19.3111 18.8999 19.8082 18.8999C20.3053 18.8999 20.7082 19.3028 20.7082 19.7999V23.3999H18.9082V19.7999Z",
    fill: "#FF772B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5068 25.3999C13.5068 24.2953 14.4023 23.3999 15.5068 23.3999H24.1068C25.2114 23.3999 26.1068 24.2953 26.1068 25.3999V26.9999H13.5068V25.3999Z",
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3086 23.4V18C24.3086 16.8065 23.8345 15.6619 22.9906 14.818C22.1467 13.9741 21.0021 13.5 19.8086 13.5C18.6151 13.5 17.4705 13.9741 16.6266 14.818C15.7827 15.6619 15.3086 16.8065 15.3086 18V23.4M24.3086 23.4C24.786 23.4 25.2438 23.5896 25.5814 23.9272C25.919 24.2648 26.1086 24.7226 26.1086 25.2V27H13.5086V25.2C13.5086 24.7226 13.6982 24.2648 14.0358 23.9272C14.3734 23.5896 14.8312 23.4 15.3086 23.4M24.3086 23.4H19.8086H15.3086M27.9086 18H28.8086M25.6586 11.25L25.2086 11.7M10.8086 18H11.7086M19.8086 9V9.9M13.4447 11.6361L14.081 12.2724",
    stroke: "#484848",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedmarker);
export default __webpack_public_path__ + "static/media/redmarker.a2985694163462f4d8eacd873a61447d.svg";
export { ForwardRef as ReactComponent };